import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {FieldComponent} from '../../field/field.component';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';


@Component({
    selector: 'app-pin-delete',
    templateUrl: './pin-delete.component.html',
    styleUrls: ['./pin-delete.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PinDeleteComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  public dialogRef: MatDialogRef<FieldComponent>,
  public dialog: MatDialog,
  public translate: TranslateService) { }

  ngOnInit(): void {
  }

  deletePin() {
    this.dialogRef.close({"option": "delete"});
  }

  cancel(): void {
    this.dialogRef.close({"option": "cancel"});
  }

}
